import worldMapMaker from "./WorldMap"
import Language from "./Language"
import City from "./towns/City"
import Citizen from './Citizen';

const models = [
  City,
  worldMapMaker,
  Citizen,
  Language,
  // Building,
  // arena,
  // zep,
  // Avernus,
  // Society,
]

export default models

